// Format price with commas and 0 decimals (e.g., 1,000, 2,500)
export const formatPrice = (price, language = 'en') => {
  if (price === null || price === undefined || price === '') return '0';
  const num = Math.round(parseFloat(price));
  
  if (language === 'ar') {
    // For Arabic, manually format with standard comma to ensure baseline comma
    const numStr = num.toString();
    const parts = [];
    for (let i = numStr.length - 1, count = 0; i >= 0; i--, count++) {
      if (count > 0 && count % 3 === 0) {
        parts.unshift(',');
      }
      parts.unshift(numStr[i]);
    }
    // Convert to Arabic-Indic numerals
    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return parts.map(char => {
      if (char === ',') return ','; // Keep standard comma
      if (/\d/.test(char)) return arabicNumerals[parseInt(char)];
      return char;
    }).join('');
  } else {
    // For English, use standard locale formatting
    return num.toLocaleString('en-US');
  }
};

// Format discount with 0 decimals (no commas)
export const formatDiscount = (discount, language = 'en') => {
  if (discount === null || discount === undefined || discount === '') return '0';
  const num = parseFloat(discount);
  // Always round to nearest integer for display
  const rounded = Math.round(num);
  
  if (language === 'ar') {
    // Convert to Arabic-Indic numerals
    return toArabicNumerals(rounded.toString());
  }
  
  return rounded.toString();
};

// Get currency symbol based on language
export const getCurrency = (language = 'en') => {
  return language === 'ar' ? 'ج.م' : 'EGP';
};

// Format price with currency suffix (supports language)
export const formatPriceEGP = (price, language = 'en') => {
  const currency = getCurrency(language);
  return `${formatPrice(price, language)} ${currency}`;
};

// Format discount with currency suffix (supports language)
export const formatDiscountEGP = (discount, language = 'en') => {
  const currency = getCurrency(language);
  return `${formatDiscount(discount, language)} ${currency}`;
};

// Convert number to Arabic-Indic numerals
export const toArabicNumerals = (num) => {
  if (num === null || num === undefined || num === '') return '٠';
  const numStr = num.toString();
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return numStr.split('').map(char => {
    if (/\d/.test(char)) return arabicNumerals[parseInt(char)];
    return char;
  }).join('');
};

// Convert Arabic-Indic numerals back to regular number string
export const fromArabicNumerals = (str) => {
  if (!str) return '';
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return str.split('').map(char => {
    const index = arabicNumerals.indexOf(char);
    if (index !== -1) return index.toString();
    return char;
  }).join('');
};

// Format number based on language (for quantity, counts, etc.)
export const formatNumber = (num, language = 'en') => {
  if (num === null || num === undefined || num === '') return '0';
  const numStr = num.toString();
  if (language === 'ar') {
    return toArabicNumerals(numStr);
  }
  return numStr;
};

// Format phone number based on language
export const formatPhoneNumber = (phoneNumber, language = 'en') => {
  if (!phoneNumber) return '';
  if (language === 'ar') {
    return toArabicNumerals(phoneNumber);
  }
  return phoneNumber;
};
